import { Component, Inject } from '@angular/core';
import { AvisosList } from 'src/app/interfaces';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-risk-modal-warning',
  templateUrl: './risk-warning-modal.component.html',
  styleUrls: ['./risk-warning-modal.component.scss']
})
export class RiskWarningModalComponent {
  constructor(
    private dialogRef: MatDialogRef<RiskWarningModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { value: AvisosList }
  ) {}

  closeModal(): void {
    this.dialogRef.close();
  }
}
